import { UserModelJsonResource } from "@/types/userTypes";
import api from "./axios";

/**
 * Settings API functions for managing user preferences and profile settings
 */
export class WorkoutApi {
  /**
   * Update user preferences (weight unit and date range)
   * @param preferences - The preferences to update
   * @returns The updated user data
   */
  async updateWorkoutTitle(
    workoutNanoId: string,
    title: string
  ): Promise<UserModelJsonResource> {
    const response = await api.post(`/api/workouts/${workoutNanoId}/title`, {
      title,
    });
    return response.data;
  }
}

export const workoutApi = new WorkoutApi();
